export const placesUrl = 'places/';
export const placeUrl = (placeId: string) => `places/${placeId}/`;
